/**
 * Converts string to
 *
 * @param {string} string Component name
 * @returns  {string}  Formated component name
 */
export default string => string.toLowerCase().replaceAll(' ', '-');
